export default __webpack_public_path__ + "static/media/date-arrow-right.5fe29b86.svg";